import { useEffect, useMemo } from "react";
import { PartyPopper } from "lucide-react";
import { playChime } from "@/lib/chime";
import { speak } from "@/lib/api";

const COLORS = ["#ef4444", "#f97316", "#eab308", "#22c55e", "#3b82f6", "#8b5cf6", "#e0a526"];

export const RewardConfetti = ({ reward, name, onClose }) => {
  const bits = useMemo(() => Array.from({ length: 80 }, (_, i) => ({
    id: i,
    left: Math.random() * 100, delay: Math.random() * 0.8, dur: 2.2 + Math.random() * 1.6,
    color: COLORS[i % COLORS.length], rot: Math.random() * 360, round: i % 3 === 0,
  })), []);
  useEffect(() => {
    playChime(true);
    speak(`Hooray${name ? ` ${name}` : ""}! You saved enough for ${reward.title}. Go tell your grown-up!`);
    const t = setTimeout(onClose, 7000);
    return () => clearTimeout(t);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="pp-confetti" onClick={onClose} data-testid="reward-confetti">
      {bits.map((b) => (
        <i key={b.id} style={{ left: `${b.left}%`, background: b.color, animationDelay: `${b.delay}s`, animationDuration: `${b.dur}s`,
          transform: `rotate(${b.rot}deg)`, borderRadius: b.round ? "50%" : 2 }} />
      ))}
      <div className="pp-confetti-card" data-testid="reward-confetti-card">
        <PartyPopper className="h-10 w-10 mx-auto text-amber-500" />
        <p className="pp-label mt-2">Reward ready!</p>
        <h2 className="pp-h2">You saved enough for</h2>
        <p className="pp-confetti-title" data-testid="reward-confetti-title">{reward.title}</p>
        <p className="opacity-75 mt-2">Show this to your grown-up.</p>
        <button className="pp-primary mt-4" onClick={onClose} data-testid="reward-confetti-close">Yay!</button>
      </div>
    </div>
  );
};
